import { gql } from "graphql-request";
export const LOGIN = gql`
  mutation Mutation($loginInfo: inputLogin!) {
    login(login_info: $loginInfo) {
      employee {
        id
        document_id
        first_name
        last_name
        email
        phone
        department
        position
        status
        line_uid
        img_url
        last_login_date
        role_list {
          id
          name
          permission_list
        }
        has_e_signature
        e_signature_img_url
      }
      token {
        access_token
        refresh_token
      }
    }
  }
`;

export const REVOKE = gql`
  mutation Mutation {
    revokeToken
  }
`;

export const REFRESH = gql`
  mutation Refresh {
    refreshToken {
      token {
        access_token
      }
    }
  }
`;
